import { render } from "./AlertIcon.vue?vue&type=template&id=c39ec8ae&scoped=true&ts=true&lang=pug"
import script from "./AlertIcon.vue?vue&type=script&lang=ts"
export * from "./AlertIcon.vue?vue&type=script&lang=ts"

import "./AlertIcon.vue?vue&type=style&index=0&id=c39ec8ae&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c39ec8ae"]])

export default __exports__